import React, { Fragment } from "react";
import moment from "moment-timezone";
import classNames from "classnames";
import { fetchLocale } from "shared/helpers/localeHelper";
import { IntlProvider, FormattedNumber } from "react-intl";

import ChallengeSectionRow from "./ChallengeSectionRow";
import "./ChallengeTableSection.scss";

const ChallengeTableSection = ({
  language,
  currency_code,
  timezone,
  challenges,
  challenge_table,
}) => {
  const currentHour = moment().tz(timezone).format("MMMM Do YYYY, h");
  const locale = fetchLocale(language);

  return (
    <Fragment>
      <IntlProvider locale={locale}>
        <div className="challenges desktop">
          <div className="challenge-title">{challenge_table.name}</div>
          <div className="challenge-subtitle">{challenge_table.description}</div>
          <div className="challenge-table">
            <div className="challenge-header">
              {challenge_table.time_type === "Hourly" && (
                <span className="challenge-header-col">Time</span>
              )}
              <span className="challenge-header-col name">Challenge</span>
              <span className="challenge-header-col">Prize</span>
              <span className="challenge-header-col">Winner</span>
            </div>
            {challenges.map((challenge, index) => (
              <ChallengeSectionRow
                currency_code={currency_code}
                challenge_table={challenge_table}
                timezone={timezone}
                key={index}
                challenge={challenge}
              />
            ))}
          </div>
        </div>
      </IntlProvider>
    </Fragment>
  );
};

export default ChallengeTableSection;
